import {
  AppBar,
  Box,
  Button,
  Container,
  Link,
  Stack,
  Toolbar,
  Typography,
} from "@mui/material";

export default function DataProcessingPolicyPage() {
  return (
    <Box sx={{ bgcolor: "background.default", minHeight: "100vh" }}>
      <AppBar position="sticky" color="inherit" elevation={1}>
        <Toolbar
          sx={{
            display: "flex",
            justifyContent: "space-between",
            height: "80px",
          }}
        >
          <Stack direction="row" spacing={2} alignItems="center">
            <Link href="/">
              <img
                src="/assets/icons/logo.png"
                alt="PrestiYA"
                style={{ height: 150 }}
              />
            </Link>
          </Stack>
          <Stack direction="row" spacing={2}>
            <Button
              variant="contained"
              color="primary"
              sx={{ borderRadius: 2 }}
              href="/"
            >
              Solicitar préstamo
            </Button>
          </Stack>
        </Toolbar>
      </AppBar>
      <Container sx={{ py: 5, minHeight: 800 }}>
        <Typography variant="h4" gutterBottom fontWeight="bold">
          Política de Tratamiento de Datos Personales – PrestiYA
        </Typography>

        <Typography paragraph>
          En cumplimiento de la Ley 1581 de 2012 y demás normas aplicables en
          Colombia, <strong>PrestiYA</strong> informa a sus clientes, empleados
          y usuarios que trata sus datos personales conforme a los principios de
          legalidad, libertad, seguridad, transparencia y confidencialidad.
        </Typography>

        <Typography variant="h6" gutterBottom>
          1. Finalidad del tratamiento
        </Typography>
        <Typography paragraph>
          Los datos personales se utilizarán para: evaluar y otorgar créditos,
          contactar a los titulares, enviar notificaciones relacionadas con sus
          productos, cumplir obligaciones contractuales y legales, y realizar
          estudios estadísticos y de mercado.
        </Typography>

        <Typography variant="h6" gutterBottom>
          2. Derechos del titular
        </Typography>
        <Typography paragraph>
          Los titulares podrán acceder, actualizar, rectificar y solicitar la
          eliminación de sus datos personales. También podrán revocar la
          autorización para su uso en cualquier momento.
        </Typography>

        <Typography variant="h6" gutterBottom>
          3. Canales de atención
        </Typography>
        <Typography paragraph>
          Para ejercer tus derechos, comunícate con nosotros al correo{" "}
          <a href="mailto:contacto@prestiya.co">contacto@prestiya.co</a>.
        </Typography>

        <Typography variant="h6" gutterBottom>
          4. Vigencia
        </Typography>
        <Typography paragraph>
          Esta política entra en vigencia a partir de su publicación y
          permanecerá vigente mientras PrestiYA realice tratamiento de datos
          personales.
        </Typography>
      </Container>
      {/* Footer */}
      <Box
        sx={{ bgcolor: "black", color: "white", py: 4, textAlign: "center" }}
      >
        <Stack
          direction="row"
          spacing={3}
          justifyContent="center"
          sx={{ mb: 1 }}
        >
          <Link href="/privacidad" underline="hover" color="primary.light">
            Política de Privacidad
          </Link>
          <Link
            href="/tratamiento-datos"
            underline="hover"
            color="primary.light"
          >
            Política de Tratamiento de Datos
          </Link>
        </Stack>
        <Typography variant="body2">
          © {new Date().getFullYear()} PrestiYA. Todos los derechos reservados.
        </Typography>
      </Box>
    </Box>
  );
}
